export default __webpack_public_path__ + "static/media/lightSensor.68281b97.svg";